import { fetchPageData } from '@search/core/services/pageData';
import { fetchSearchData } from '@search/core/services/searchData';
import { fetchSeoData } from '../seoData';
export const fetchSerpData = async ({ searchModel, searchServiceModel, page, pageSize, order, bffUri, language, brand, stage, seoModel, searchEndpoints, numberOfSuggestions = 0, }) => {
    if (!searchModel || !searchServiceModel)
        throw new Error('searchModel is undefined');
    const [searchData, pageData, { linkboxes = [], breadcrumb = [], content = {} }] = await Promise.all([
        fetchSearchData({
            searchServiceModel,
            page,
            pageSize,
            order,
            bffUri,
            language,
            brand,
            stage,
            searchEndpoints,
            numberOfSuggestions,
        }),
        fetchPageData({ searchModel, bffUri }),
        fetchSeoData({ seoModel, page, pageSize, language, order, bffUri }),
    ]);
    return [searchData, pageData, linkboxes, breadcrumb, content];
};
